import { Provider, Type } from "@angular/core";
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from "@angular/forms";

export class ComponentUtility {
    static createValueAccessorProvider<T>(type: Type<T>): Provider {
        return {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: type
        };
    }

    static createValidatorProvider<T>(type: Type<T>): Provider {
        return {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: type
        };
    }
}
